/**
 * Build the multipart `File` Track 2 uploads to `POST …/imports`.
 *
 * Slice 5 source-import adapters (`CompanyShellSourceImportAdapter`,
 * `WorkPatternSourceImportAdapter`, `PayComponentSourceImportAdapter`) all
 * parse UTF-8 JSON arrays of canonical rows — the portal already turns CSV
 * into that shape client-side. The API router also rejects `text/csv`
 * (`415 Unsupported content type … expected a JSON upload`).
 */
export function rowsToJsonImportFile(
  rows: unknown[],
  originalFileName?: string | null
): File {
  const rawName = (originalFileName ?? "upload").trim() || "upload";
  const stem = rawName.replace(/\.[^.]+$/, "") || "upload";
  return new File([JSON.stringify(rows)], `${stem}.json`, {
    type: "application/json",
  });
}
